import { useTheme } from "../../../../../context/ThemeContext";

export default function Menu() {
  const { theme } = useTheme();

  const cellStyle = {
    flex: 1,
    textAlign: "center",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    fontSize: 12,
  };

  return (
    <div
      className="bg-[var(--primary)] text-white"
      style={{
        display: "flex",
        height: 40,
        alignItems: "center",
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <div style={{ ...cellStyle, flex: 1 }}>SYMBOL</div>
      <div style={{ ...cellStyle, flex: 1 }}>EXPIRY</div>
      <div style={{ ...cellStyle, flex: 1 }}>MIN</div>
      <div style={{ ...cellStyle, flex: 1 }}>ORDER</div>
      <div style={{ ...cellStyle, flex: 1 }}>MAX</div>
      <div style={{ ...cellStyle, flex: 1 }}>LOT</div>
      <div style={{ ...cellStyle, flex: 1 }}>MARGIN</div>
    </div>
  );
}
